<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" @keyup.enter.native="submitForm" ref="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划名称" prop="planName">
              <a-input placeholder="请输入计划名称" v-model="model.planName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="保养设备" prop="devId">
              <!-- <j-select-device :multiple="true" @select="selectDevChange" placeholder="请选择设备" v-model="model.devId" /> -->
              <j-tree-select-device :multiple="true" placeholder="请选择保养设备" v-model="model.devId"></j-tree-select-device>
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划类型" prop="planType">
              <j-dict-select-tag
                :showPlease="false"
                @change="planTypeChange"
                dictCode="plan_class"
                placeholder="请选择计划类型"
                v-model="model.planType"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="`计划周期`" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="planCycle">
              <j-dict-select-tag
                :showPlease="false"
                dictCode="planning_cycle"
                placeholder="请选择计划周期"
                v-model="model.planCycle"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划日期" prop="planDate">
              <template v-if="model.planCycle!=3">
                <a-checkbox-group :options="planDateList" v-if="String(model.planType)==='2'" v-model="model.planDate" />
                <a-radio-group :options="planDateList" v-if="String(model.planType)==='1'" v-model="model.planDate"></a-radio-group>
              </template>
              <template v-else>
                <template v-for="(tag, index) in planTags" v-if="planTags.length>0">
                  <a-tooltip :key="tag" :title="tag">
                    <a-tag :key="tag" @close="() => handleClose(tag)" closable>{{ tag }}</a-tag>
                  </a-tooltip>
                  <!-- <a-tag :closable="index !== 0" :key="tag" @close="() => handleClose(tag)" v-else>{{ tag }}</a-tag> -->
                </template>
                <a-tag @click="showYearDom" color="#1890FF" v-if="!selectYear">
                  <a-icon type="plus" />新增
                </a-tag>
                <a-tag @click="()=>selectYear=false" color="#1890FF" v-if="selectYear">完成</a-tag>
                <div v-if="selectYear">
                  <div style=" border: 1px solid #d9d9d9; border-radius: 4px">
                    <a-calendar :fullscreen="false" :header-render="headerRender" @change="onPanelChange" />
                    <!--  @panelChange="onPanelChange" -->
                  </div>
                </div>
              </template>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="保养时间" prop="maintenanceStartTime">
              <a-time-picker v-model="model.maintenanceStartTime" valueFormat="HH:mm:ss" />
              <span style="margin: 0 10px;display: inline-block;">-</span>
              <a-time-picker v-model="model.maintenanceEndTime" valueFormat="HH:mm:ss" />
              <!-- <j-date placeholder="请选择保养时间" style="width: 100%" v-model="model.nextTime" /> -->
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="提醒时间（分钟）" prop="reminderTime">
              <a-input placeholder="请输入提醒时间（分钟）" v-model="model.reminderTime"></a-input>
            </a-form-model-item>
          </a-col>
          <!-- planStatus -->
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划状态" prop="planStatus">
              <!-- <a-input placeholder="请输入提醒时间（分）" v-model="model.planStatus"></a-input> -->
              <a-radio-group v-model="model.planStatus">
                <a-radio :value="1">启用</a-radio>
                <a-radio :value="0">停用</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="责任人" prop="responsible_id">
              <!-- <a-input placeholder="请输入提醒时间（分）" v-model="model.planStatus"></a-input> -->
              <!-- <j-select-multi-user :multiple="false" v-model="model.responsibleId"></j-select-multi-user> -->
              <j-search-select-tag
                :async="true"
                :pageSize="100"
                dict="sys_user,realname,id"
                placeholder="请选择责任人"
                tenant="rel_tenant_ids"
                v-model="model.responsibleId"
              ></j-search-select-tag>
              <!-- <j-select-user-by-dep v-model="model.responsible_id" /> -->
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  // import { validateDuplicateValue } from '@/utils/util'
  import { initDictOptions } from '@/components/dict/JDictSelectUtil'
  import JCheckbox from '@/components/jeecg/JCheckbox'
  import * as _ from 'lodash'
  import moment from 'moment'
  import { mapGetters } from "vuex";

  export default {
    name: 'DevMaintaincePlanForm',
    // components: { JCheckbox },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    components: {
      JCheckbox
    },
    data () {
      return {

        model: {
          planCycle: 3,
          planType: '2',
          planStatus: 1,
          planDate: [],
          reminderTime: 30,

          // moment('18:00:00', 'HH:mm:ss')
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        validatorRules: {
          planName: [
            { required: true, message: '请输入保养计划名称!' },
          ],
          devId: [
            { required: true, message: '请选择保养设备!' },
          ],
          reminderTime: [
            { required: true, message: '请输入提醒时间!' },
          ],
          planDate: [
            { required: true, message: '请选择计划日期!' },
          ],
          maintenanceStartTime: [
            { required: true, message: '请选择保养时间!' },
            {
              validator: (rule, value, callback) => {

                if (!this.model.maintenanceStartTime || !this.model.maintenanceEndTime) {
                  callback(new Error('请选择保养时间!'));

                } else {
                  callback();
                }
              },
              trigger: ['blur', 'change']
            },
          ],
        },
        url: {
          add: '/maintenance/devMaintaincePlan/add',
          edit: '/maintenance/devMaintaincePlan/edit',
          queryById: '/maintenance/devMaintaincePlan/queryById',
          idList: '',
          planDevById: '/maintenance/devMaintaincePlanDevice/queryByPlanId'
        },
        devMaintenanceStlIdList: [],
        // planDateList: [],
        // 保养设备list
        planDevList: [],
        // 计划日期，周
        planWeekList: [],
        planMonthList: [],
        planTags: [],
        selectYear: false
      }
    },
    computed: {
      ...mapGetters(['username']),

      formDisabled () {
        return this.disabled
      },
      planDateList () {
        return this.model.planCycle !== 3 ? (this.model.planCycle == 2 ? this.planMonthList : this.planWeekList) : []
      }
    },
    async created () {

      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model))

      this.getPlanDateList()

      const { result, success } = await initDictOptions('planned_date')
      if (success) {
        this.planWeekList = result.reduce((pre, cur) => {
          pre.push({
            label: cur.text,
            value: cur.value
          })
          return pre
        }, []);

      }
    },
    methods: {
      moment,
      onSelect () { },
      onPanelChange (v) {
        const planTags = _.clone(this.planTags)
        const momentDate = v.format('MM-DD')
        if (!planTags.includes(momentDate)) {
          planTags.push(momentDate)
          this.planTags = planTags
          this.planDate = planTags
        }
      },
      showYearDom () {
        this.selectYear = true
      },
      handleClose (removedTag) {
        const tags = this.planTags.filter(tag => tag !== removedTag);
        this.planTags = tags;
      },
      planTypeChange (v) {
        this.model.planDate = v == 1 ? '' : []
      },
      selectDevChange (v) {
        const devList = v.map(item => {
          const { devClassId, id, devName } = item
          return {
            devClassId,
            devId: id,
            devName
          }
        })
        this.planDevList = devList
      },
      getPlanDateList () {
        let arr = new Array(31).fill(0)
        this.planMonthList = arr.map((v, index) => {
          return {
            label: index + 1 + '号',
            value: index + 1
          }
        })
      },
      // handleTimeChange(val) {
      //   if (val) {
      //     this.model.maintenanceStartTime = moment(val[0]).format('YYYY-MM-DD')
      //     this.model.maintenanceEndTime = moment(val[1]).format('YYYY-MM-DD')
      //   }
      // },
      getDevMaintenanceStlIdList () {
        getAction(this.url.IdList, '').then((res) => {
          this.devMaintenanceStlIdList = res.result.records.map((item) => {
            return {
              value: item.id,
              label: item.typeName
            }
          })
        })
      },
      headerRender ({ value, type, onChange, onTypeChange }) {
        const start = 0;
        const end = 12;
        const monthOptions = [];
        const that = this
        const current = value.clone();
        const localeData = value.localeData();
        const months = [];
        for (let i = 0; i < 12; i++) {
          current.month(i);
          months.push(localeData.monthsShort(current));
        }

        for (let index = start; index < end; index++) {
          monthOptions.push(
            <a-select-option class="month-item" key={`${index}`}>
              {months[index]}
            </a-select-option>,
          );
        }
        const month = value.month();

        const year = value.year();
        const options = [];
        for (let i = year - 10; i < year + 10; i += 1) {
          options.push(
            <a-select-option key={i} value={i} class="year-item">
              {i}
            </a-select-option>,
          );
        }
        //             

        return (
          <div style={{ padding: '10px' }}>
            <a-row type="flex" justify="space-between">
              <a-col>
                <div >年度计划</div></a-col>
              <a-col>
                <a-select

                  style="width:100px;"
                  // dropdownMatchSelectWidth={false}
                  value={String(month)}
                  onChange={selectedMonth => {
                    const newValue = value.clone();
                    newValue.month(parseInt(selectedMonth, 10));
                    onChange(newValue);
                  }}
                >
                  {monthOptions}
                </a-select>
              </a-col>

            </a-row>
          </div >
        );
      },
      add () {
        this.edit(this.modelDefault)
      },
      edit (record) {
        const modelData = _.cloneDeep(record)
        if (!modelData.id) {
          modelData.responsibleId = this.$ls.get('Login_UserId')
          modelData.maintenanceStartTime = moment('080000', 'HHmmss')
          modelData.maintenanceEndTime = moment('180000', 'HHmmss')
        }
        if (modelData.planType == 2) {
          if (modelData.id && modelData.planCycle != 3) {
            modelData.planDate = modelData.planDate.split(',').map(item => {
              return modelData.planCycle == 1 ? item : Number(item)
            })
          }
        }
        if (modelData.planType == 1 && modelData.planCycle == 2) {
          modelData.planDate = Number(modelData.planDate)
        }

        // if (modelData.planCycle == 2) {
        //   modelData.planDate = Number(modelData.planDate)
        // }
        if (modelData.planCycle == 3 && modelData.id) {
          this.planTags = modelData.planDate.split(',')
        }
        this.model = Object.assign({}, modelData)

        if (this.model.id) {
          let params = { planId: this.model.id }
          getAction(this.url.planDevById, params).then(res => {
            this.planDevList = res.result
          })

        }
        //  this.planDevList = this.model.devMaintaincePlanDeviceList
        this.visible = true
      },
      submitForm () {
        const that = this
        // 触发表单验证
        if (that.model.planCycle == 3) {
          that.model.planDate = that.planTags
        }
        this.$refs.form.validate((valid) => {
          if (valid) {

            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!this.model.id) {
              httpurl += this.url.add
              method = 'post'
            } else {
              httpurl += this.url.edit
              method = 'put'
            }
            const modelData = _.cloneDeep(this.model)
            modelData.devName = this.planDevList.map(item => item.devName).join()
            if (modelData.planType == 2) {
              modelData.planDate = modelData.planDate.join()
            }
            if (modelData.planCycle == 3) {
              modelData.planDate = this.planTags.join()
            }
            if (Object.prototype.toString.call(modelData.maintenanceStartTime) != "[object String]") {
              modelData.maintenanceStartTime = moment(modelData.maintenanceStartTime).format('HH:mm:ss')
            }
            if (Object.prototype.toString.call(modelData.maintenanceEndTime) != "[object String]") {
              modelData.maintenanceEndTime = moment(modelData.maintenanceEndTime).format('HH:mm:ss')
            }

            httpAction(httpurl, { ...modelData, devMaintaincePlanDeviceList: this.planDevList }, method)
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message)
                  that.$emit('ok')
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.confirmLoading = false
              })
          }
        })
      }
    },
    watch: {
      'model.planCycle': {
        immediate: true,
        handler (v) {

        }
      }
    }
  }
</script>

<style lang="less" scoped>
  ::v-deep {
    .ant-checkbox-group {
      margin-top: 10px;
      &-item {
        margin-bottom: 6px;
        min-width: 64px;
        .ant-checkbox + span {
          padding-right: 7px;
        }
      }
    }
    .ant-radio-wrapper {
      margin-bottom: 12px;
      margin-right: 6px;
      min-width: 64px;
    }
  }
</style>